// Import Swiper React components
// Import Swiper styles
import 'swiper/css';

import Avo from 'analytics/Avo';
import type { PricingList } from 'api/types/pricing.types';
import Separator from 'components/molecules/Separator';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Indicator from './indicator';
import data from './slider-data';
import Item from './slider-item';

interface Props {
  serviceType: string;
  serviceDetails?: PricingList.CombinedService;
}

const StyledTitle = styled.h5`
  font-weight: 300;
  font-size: 12px;
  padding: 0 1.5rem;
`;

const BoldSpan = styled.span`
  font-weight: 500;
`;

const StyledSlider = styled(Swiper)``;

const StyledDiv = styled.div`
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 8px;
`;

const Slider = ({ serviceType }: Props) => {
  const { t } = useTranslation();
  const showImageSlider = useMemo(
    () =>
      data.get(serviceType)?.content.map((_data, i) => (
        <SwiperSlide
          key={_data.poster}
          onClick={() => {
            Avo.estimatorCarouselVideos({ screen: i.toString() });
          }}
        >
          <Item isVideoDisabled {..._data} />
        </SwiperSlide>
      )),
    [serviceType]
  );

  const SliderContent = useMemo(
    () => (
      <StyledSlider modules={[Autoplay]} spaceBetween={0} slidesPerView={1} autoplay={{ delay: 5000 }} style={{ minHeight: 180 }} loop>
        {showImageSlider}
        <Indicator />
        <StyledDiv>
          <StyledTitle>
            <Trans
              t={t}
              i18nKey={data.get(serviceType)?.title}
              components={{
                bold: <BoldSpan />,
              }}
            />
          </StyledTitle>
        </StyledDiv>
        <Separator noMargin />
      </StyledSlider>
    ),
    [showImageSlider, t, serviceType]
  );

  return SliderContent;
};

export default Slider;
